export const en = {
  "NAVIGATION": {
    "HOME": "Home",
    "PORTFOLIO": "Portfolio",
    "PROFILE": "Profile"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "Search in Available Deals",
      "TITLE": "Search only in Available Deals section"
    },
    "QUICK_FILTERS": {
      "TITLE": "Quick Filters",
      "CAPTION": "Choose category type",
      "DEFI": "DeFi",
      "STAKING": "Staking",
      "FARMING": "Farming",
      "LENDING": "Lending",
      "MINING": "Mining",
      "TRADING": "Trading",
      "ALL": "All",
      "STABLECOINS": "Stablecoins",
      "DEPOSITS": "Deposits",
      "DEXES": "DEXes"
    },
    "PREMIUM_DEALS": {
      "TITLE": "Premium Deals",
      "CAPTION": "The best deals of the week",
      "NO_DEALS": "No deals",
      "NO_DEALS_AVAILABLE": "No deals available",
      "GET_PREMIUM": "Get Premium",
      "APY": "APY",
      "NETWORK": "Network",
      "TOKEN_TYPE": "Token Type"
    },
    "FILTERS": {
      "TITLE": "Filters",
      "FILTERS": "Filters",
      "SELECT_FILTERS": "Select filters to apply",
      "APPLY": "Apply"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "Available Deals",
      "CAPTION": "New market opportunities",
      "NO_DEALS": "No opportunities found"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "Subscription Status",
      "CAPTION": "Details of your premium membership",
      "ACTIVE": "ACTIVE",
      "INACTIVE": "INACTIVE",
      "PERIOD": "Period",
      "EXPIRES": "Expires",
      "PROGRESS": "Subscription Progress",
      "NOT_STARTED": "Not Started"
    },
    "REFERRAL": {
      "TITLE": "Referral Program",
      "CAPTION": "Invite friends and earn points",
      "RANK": "RANK",
      "TOTAL_REFERRALS": "Total Referrals",
      "ACTIVE_REFERRALS": "Active Referrals",
      "REFERRALS_BY_LEVEL": "Referrals by Level",
      "COPY": "Copy",
      "POINTS_TO_NEXT_RANK": "{{points}} points to next rank"
    },
    "PREMIUM": {
      "TITLE": "Premium Subscription",
      "CAPTION": "Choose a plan and get access to premium features",
      "MONTHS": "months",
      "BEST_VALUE": "Best Value",
      "PAYMENT_METHOD": "Payment Method",
      "TELEGRAM_STARS": "Telegram Stars",
      "CRYPTO": "Cryptocurrency",
      "YOU_SAVE": "You save",
      "PROCESSING": "Processing...",
      "PAY_STARS": "Pay {{amount}} Stars",
      "PAY_CRYPTO": "Pay ${{amount}} in crypto",
      "PAYMENT_SUCCESS": {
        "TITLE": "Payment Successful",
        "MESSAGE": "Your subscription has been successfully activated!"
      },
      "PAYMENT_ERROR": {
        "TITLE": "Payment Error",
        "MESSAGE": "Failed to process payment. Please try again.",
        "STARS_INSUFFICIENT": "Insufficient stars for payment. Please top up your stars balance via @PremiumBot."
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "Payment Cancelled",
        "MESSAGE": "You cancelled the payment. Try again when you are ready."
      },
      "PAYMENT_PENDING": {
        "TITLE": "Payment Processing",
        "MESSAGE": "Your payment is being processed. Please wait."
      },
      "BUTTONS": {
        "OK": "OK",
        "CANCEL": "Cancel",
        "BUY_STARS": "Buy Stars"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "Early access to Premium Deals with highest APY",
      "EXCLUSIVE_DEFI": "Exclusive DeFi opportunities with up to 80% APY",
      "NOTIFICATIONS": "Real-time notifications for new Premium Deals",
      "GUIDES": "Detailed step-by-step guides and strategies",
      "INSIGHTS": "Weekly market insights and recommendations"
    },
    "FOOTER": {
      "CONTACT": "If you have any questions, contact us at:",
      "EMAIL_COPIED": "Email address copied to clipboard",
      "SUPPORT_TITLE": "Support",
      "SUPPORT_CAPTION": "Contact us if you have any questions",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram"
    },
    "LANGUAGE": {
      "TITLE": "Language Settings",
      "CAPTION": "Choose your preferred language",
      "LANGUAGES": {
        "EN": "English",
        "RU": "Russian",
        "UK": "Ukrainian",
        "ES": "Spanish",
        "AR": "Arabic",
        "ZH": "Chinese"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "Portfolio Strategy",
    "SUBTITLE": "Overview of available portfolio strategies",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "Capital Preservation",
        "DESCRIPTION": "Low-risk strategy focused on capital preservation through stablecoins with stable yield generation",
        "RISK_LEVEL": "Low risk"
      },
      "MODERATE": {
        "NAME": "Cashflow",
        "DESCRIPTION": "Low-risk strategy focused on stable income through stablecoins and blue-chip cryptocurrencies",
        "RISK_LEVEL": "Low risk"
      },
      "BALANCED": {
        "NAME": "Balanced",
        "DESCRIPTION": "Moderate-risk balanced strategy including stablecoins, blue-chip cryptocurrencies, and selected altcoins",
        "RISK_LEVEL": "Moderate risk"
      },
      "AGGRESSIVE": {
        "NAME": "Growth",
        "DESCRIPTION": "High-risk growth strategy focused on blue-chip cryptocurrencies and promising altcoins",
        "RISK_LEVEL": "High risk"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "Stablecoins",
      "BLUE_CHIPS": "Blue chips",
      "TOP_ALTCOINS": "Top altcoins",
      "OTHER_ALTCOINS": "Other altcoins",
      "INDICES": "Indices"
    },
    "DETAILS": {
      "ASSETS": "Assets",
      "YIELD_STRATEGY": "Yield Strategy",
      "APY_PROJECTION": "APY Projection"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "Back",
    "PROJECT_NOT_FOUND": "Project not found",
    "SETUP_STEPS": "Setup Steps",
    "GO_TO_PROJECT": "Go to Project",
    "STATS": {
      "APY": "APY"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "Prepare Web3 Wallet",
        "DESCRIPTION": "Install and set up a Web3 wallet that supports the selected network. For example, install MetaMask for Ethereum-based networks, Phantom for Solana, or Sui Wallet for the Sui network. Make sure your wallet is properly configured and secured."
      },
      "CONNECT_NETWORK": {
        "TITLE": "Connect Network",
        "DESCRIPTION": "Add and connect to the correct blockchain network in your wallet. If the network is not automatically added, you may need to manually add it using the network's RPC URL, Chain ID, and other network details. Ensure you're connected to the right network before proceeding."
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "Check Gas Balance",
        "DESCRIPTION": "Ensure you have enough native tokens in your wallet to cover transaction fees (gas). For Ethereum networks you need ETH, for Solana - SOL, for Sui - SUI. The exact amount needed will depend on network congestion and transaction complexity."
      },
      "PREPARE_ASSETS": {
        "TITLE": "Prepare Assets",
        "DESCRIPTION": "Transfer or acquire the specific tokens you want to invest (like USDC, USDT, or DAI) to your connected wallet. Make sure the tokens are on the correct network - some tokens exist on multiple networks but aren't transferable between them directly."
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "Oops! Something went wrong",
    "DEFAULT_MESSAGE": "An error occurred. Please try again later.",
    "RETRY_BUTTON": "Try again",
    "SPECIFIC_ERRORS": {
      "DOCKER": "Service is temporarily unavailable. Please try again in a few minutes.",
      "NETWORK": "Network connection issue. Please check your internet connection.",
      "SERVICE": "Service is temporarily unavailable. Our team is working on it.",
      "DATABASE": "Database access issue. Please try again later."
    }
  }
}; 